import React from "react";
import styled from "styled-components";

import { PanelContext } from "../../contexts/PanelContext";
import { buttonReset } from "../../utils/theme";
import Icon from "../shared/Icon";
import Text from "../shared/Text";
import DesktopFiltersWrapper from "./DesktopFiltersWrapper";
import MobileFiltersWrapper from "./MobileFiltersWrapper";
import { LoadingContext } from "../../contexts/LoadingContent";

const Header: React.FC = () => {
  const [{ open: isPanelOpen }, setPanel] = React.useContext(PanelContext);
  const [{ isCartoucheComplete }] = React.useContext(LoadingContext);

  const handlePanel = React.useCallback(
    (type) => {
      if (isPanelOpen) {
        setPanel({
          open: false,
        });
      } else {
        setPanel({
          open: true,
          data: {
            type,
          },
        });
      }
    },
    [isPanelOpen, setPanel]
  );

  const [mobileFilters, setMobileFilters] = React.useState(false);
  return (
    <>
      <HeaderWrapper className={isCartoucheComplete ? "active" : "hidden"}>
        <HeaderLeft>
          <AboutButton onClick={() => handlePanel("about")}>
            <Icon icon="info" />
          </AboutButton>
          <MapTitle>
            <Icon size={45} fillColor="accent" icon="logo" />
            <Text as="h3">Voices of England</Text>
          </MapTitle>
        </HeaderLeft>
        <HeaderRight>
          <DesktopFiltersWrapper />
          {/* <SubmitYourStoryButton onClick={() => handlePanel("story-form")}>
            <Icon size={25} fillColor="accent" icon="story" />
            <Text color={"accent"} as="h4">
              Submit a saying
            </Text>
          </SubmitYourStoryButton> */}
        </HeaderRight>
      </HeaderWrapper>
      <MobileFilterButton onClick={() => setMobileFilters(true)}>
        <Icon icon="burger" size={25} fillColor="accent" />
      </MobileFilterButton>
      <MobileFiltersWrapper
        isOpen={mobileFilters}
        onClose={() => setMobileFilters(false)}
      />
    </>
  );
};

const MobileFilterButton = styled.button`
  position: fixed;
  border-radius: 100%;
  background: white;
  padding: 1rem;
  bottom: 1rem;
  left: 1rem;
  border: none;
  z-index: 70;
  display: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  @media (max-width: 960px) {
    display: flex;
  }
`;
const HeaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  display: flex;
  flex-direction: row;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  user-select: none;
  z-index: 100;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  opacity: 0;
  transition: all ease-in-out 0.3s;
  pointer-events: none;
  &.active {
    pointer-events: all;
    opacity: 1;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem 2rem;
  @media (max-width: 960px) {
    padding: 0.6rem 1rem;
  }
`;
const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const AboutButton = styled.div``;

const SubmitYourStoryButton = styled.button`
  ${buttonReset}
  height: 100%;
  background: #efeaea;
  padding: 2rem 1.6rem;
  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
  }
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: all ease-in-out 0.3s;
  h4 {
    padding-left: 0.75rem;
  }

  &:focus,
  &:hover {
    background: #e0d7d7;
  }
`;

const MapTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 2rem;
  @media (max-width: 960px) {
    padding-left: 1rem;
  }
  h3 {
    padding-left: 0.75rem;
  }
`;

export default Header;
